module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_20"
  }, [_c('span', {
    staticClass: "text_2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "toc_id_6"
    }
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("January")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Becky felt the fear rising in her throat but she was powerless to do anything to prevent it as the tiny boat slithered and bucked on the crest of an enormous wave that threatened to engulf them. She sat alone in the boat on the dark, treacherous sea, except for the strange, silent man at the helm. On one side of the boat, the sea seemed to fall away into a dark, bottomless pit with jagged black rocks waiting with open jaws, but on the other side, the boiling water appeared clear and unthreatening, and in the distance Becky could make out the harbour wall, one minute seeming to be impossibly far away and the next to be within reach. On the harbour wall, stood a tall figure, silhouetted and lonely.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("And then the rain came down and blotted out the tall man. Becky felt suddenly desperately alone and without hope, and instinctively knew that the little boat was set on a collision course with the cruel rocks below.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("She awoke with a start and heard, as if from a long way off, the rain lashing against the old window panes. She felt terrified, still in the grips of the nightmare that had returned once again to haunt her. Becky groaned inwardly, which was worse, her recurring nightmare or the nightmare situation of her everyday world? Outside was a bleak January night with the rain tipping down and the wind howling like a banshee, no doubt ripping off the roof tiles and flinging them around like wastepaper.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Wearily Becky crawled out of the warm bed, taking care not to disturb her husband Rob who snored loudly in total oblivion. She felt a brief flash of annoyance that he could remain so blissfully unaware of the fact that she was now wide awake and that it was the middle of the night, and that she was bound to be shattered in the cold light of day.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("The old house seemed to sigh and groan like a ship in a storm, and Becky had to steel herself to leave the confines of the bedroom and venture out onto the pitch-black landing.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“Damn,” she swore softly as she trod on the creakiest floorboard on the entire landing that happened to be just outside Polly’s bedroom. Polly slept lightly, like her mother, and would never go back to sleep if she was awakened now, in the middle of the night, by ghostly creaks and groans.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Becky held her breath for a few moments, then exhaled a sigh of relief when no answering wail came from her daughter’s bedroom.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“Damn,” she swore again, “where is that ruddy torch?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("William, just six, was already in the army. His whole bedroom was festooned like the inside of a soldier’s tent, and of course her bedside torch always disappeared the moment William’s own torch went missing.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“…story of my life,” Becky grumbled as she crept across the large landing towards the head of the winding staircase. ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("God, what a crabby old bat I am.")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(" she thought briefly before groping her way downstairs, tripping over her long winter ")]), _c('span', {
    staticClass: "text_9"
  }, [_vm._v("nightie three steps from the bottom and slipping")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(" ungracefully onto the cold hall floor below.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“Bloody hell!” she exclaimed very loudly, still nervous after the nightmare.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("No one heard or even stirred.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("All the floorboards and doors creaked unbearably in the ‘Old Mill House.’ The sitting room door leading off the hall was the worst of all. Becky was always meaning to do something about the creaking doors, like pouring her precious, hoarded olive oil onto the ancient hinges, but of course she never got round to it.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Having successfully negotiated the obstacles in her path, Becky was now anxious to reach the confines of the warm, cosy kitchen as soon as possible; in her dream-wake state she was starting to believe that something really awful was about to happen as it frequently did in her dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“Please don’t wake the children,” she prayed silently as she opened the kitchen door quietly. Flake and Cadbury, the family mongrels, barked in unison.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("The dogs’ tails thumped hard against the sides of their large, blanketed basket, but they were too snug by the Aga to venture out.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Lucky things")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(", she thought crossly.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Then, turning on the low table lamp, Becky bent down to hug the dogs, sighing heavily, “Hello, girls, yes it is me, and it’s three o’clock in the morning—would you like a biscuit?” “Yes, please!” the tails wagged in unison.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("If only my world could be contained inside this warm sanctuary")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(", she thought as she set the heavy kettle to boil on the Aga. The wind outside was now thundering and shaking the old house, and despite its thick walls Becky wondered if, at any moment, the sea would break loose and come tearing across the marshes towards the house on the top of the hill. The children would love it. No school and playing desert islands … rescue helicopters dropping in supplies …")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("The tea made and biscuits dispensed, Becky sat curled up in her favourite chair beside the Aga. The cat, Maurice, yawned in her face from his own place of comfort beside the warm stove.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“What about the poor, wretched hens, and Polly’s rabbit?” Becky panicked momentarily. But she gave in to the warmth, and sipping her tea, dismissed as impossible the thought that she might actually venture outside to check on the animals.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Outside, the hens squawked alarmingly and Paws waffled his nose rapidly, more so than usual.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("The warmth of the kitchen and the even breathing of the dogs lulled Becky back into sleep. But again peace was shattered when the mug of tea slipped from her hands and crashed to the flagstone floor with a loud explosion of tinkling china. Cursing once more, Becky sat bolt upright before heaving herself out of the chair and clearing up the mess before determinedly making for the back door; here she plunged her warm bare feet into soggy, freezing cold Wellingtons and slung on her battered old Barbour, before stumbling outside via the conservatory into the wild night.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Becky made encouraging noises to the frightened rabbit in his hutch, and then groped her way towards the orchard at the back of the house and the rattling hut full of hysterical hens. She checked the doors and windows, hoping that the henhouse roof would not take off, then set off back towards the house with visions of herself clearing up the mess of uncooked scrambled eggs amongst other delights as soon as it was light.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("By the time Becky returned to the kitchen, she was wide awake and her mind was buzzing. She knew it would be months, not weeks, before Rob was fit and well again. The loss of his accounts clerk job at a nearby technical college and the subsequent traumatic period of real depression, had taken its toll on them all. Even the children had become subdued, and certainly more difficult to control. Becky felt quite unashamedly desperate.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Nursing a second hot cup of tea, Becky pondered her situation and knew that she had reached a watershed and that tomorrow—no, today—she must go out and get herself a job. ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("It could be anything")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(", she thought; anything at all, from cleaning to typing, from weighing out vegetables to holding a victim’s hand whilst the dentist drilled the root out of his or her inflamed jaw. As long as she was out earning during school hours, it would be something, even if it was only enough to put food on the table. Becky and Rob had just about enough funds for the moment to cope with the mortgage and other household expenses, so if she could earn something to take care of the food bills, it would make her feel she was doing something positive towards their desperate and potentially disastrous situation.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("It shouldn’t be difficult")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(", she thought, but at the same time Becky knew it wasn’t going to be a push-over, living as they did at the edge of the sleepy village of Little Millston, with Crowminster 12 miles to the east and Bedhampton the same distance to the west. It just didn’t seem to make sense travelling all that way just for a few hours’ work—, half her pay would go on petrol for their ageing blue Renault. ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("It certainly won’t be like falling into jobs like I did when I was in London")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(", Becky reflected soberly.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("She stood up purposefully, made herself a cup of strong, black coffee and began scrabbling about in an old box of newspapers under the kitchen table, desperate in case she had, as usual, burnt the most up-to-date copy of the local paper instead of the most out-of-date.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("“For heaven’s sake, get a grip girl, get yourself organised,” she muttered fiercely, scanning the ‘Jobs Vacant’ page of the ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("Western Daily Packet")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v(". Becky had in fact browsed through the jobs section every week since Rob had lost his job, but because there was always so much else to do, it was invariably a half-hearted, ‘oh well, it-can-wait-for-tomorrow,’ sort of search. But now, in the depths of January and the horrendous storm, Becky knew that she must, without any further delay, take up the reins herself before they slipped into some unbearable sort of oblivion. She had very little confidence left in herself, but she would have to weather that one as she went along.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("Becky glanced at the kitchen clock ticking peacefully away and saw to her surprise that it was already 6 o’clock, and although it wouldn’t start to get light for a while, she managed to quietly mount the stairs and creep along to the spare bathroom at the end of the long landing to run herself a bath.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("As Becky relaxed in the hot water, she felt her resolve strengthening with the promise of daylight ahead; there had been two possible job opportunities, one typing up law reports for a local solicitor and the other working for a wine importer as his secretary; there was a glimmer of hope…she would fight for her home and her family.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a93162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 81
// module chunks = 0